import { useEffect, useRef } from "react";
import { isMobile, scroll2Top } from "../../utils/utils";
import RESituationBloc from "../../blocs/retirement/RESituationBloc";
import GeneralDataProtectionBloc from "../../blocs/common/GeneralDataProtectionBloc";


export default function RESituationPage() {
    
    const pageGapRef = useRef<null | HTMLDivElement>(null);
    useEffect(() => {
      if (isMobile()) {
        pageGapRef.current?.scrollIntoView() 
      } else {
        scroll2Top();
      }
    }, []);

    
    return (
      <div className="entreprise-container">
        <h1 className="title ml-lg-desktop mb-sm fw-medium">Ma situation</h1>
        <p className="text ml-lg-desktop mt-sm" style={{textAlign: 'justify'}}>Ces informations sont nécessaires à l'estimation de votre cotisation</p>
        <div ref={pageGapRef} className="page-gap" />
        <div className="flex-grid m-lg-desktop">
            <RESituationBloc />
        </div>
        <div className="m-lg-desktop">
          <GeneralDataProtectionBloc/>
        </div>
      </div>
    )

}